import AddImport from "./Add.tsx";
import AdultProfileImport from "./Adult_Profile.tsx";
import ArrowDownImport from "./ArrowDown.tsx";
import ArrowDownFilledImport from "./ArrowDownFilled.tsx";
import ArrowLeftImport from "./ArrowLeft.tsx";
import ArrowLeftNewImport from "./ArrowLeftNew.tsx";
import ArrowRightImport from "./ArrowRight.tsx";
import ArrowRightNewImport from "./ArrowRightNew.tsx";
import ArrowUpImport from "./ArrowUp.tsx";
import AudioSubtitlesKidsImport from "./AudioSubtitlesKids.tsx";
import BackgroundImageImport from "./BackgroundImage.tsx";
import BadgeAndoidImport from "./BadgeAndoid.tsx";
import BadgeAppleImport from "./BadgeApple.tsx";
import BlackImport from "./Black.jpeg";
import BookmarkImport from "./Bookmark.tsx";
import BookmarkFilledImport from "./BookmarkFilled.tsx";
import BookmarkWhiteImport from "./BookmarkWhite.tsx";
import CameraImport from "./Camera.tsx";
import ChannelsWhiteImport from "./ChannelsWhite.tsx";
import CheckImport from "./Check.tsx";
import CheckboxSelectImport from "./CheckboxSelect.tsx";
import CheckboxUnselectImport from "./CheckboxUnselect.tsx";
import CloseImport from "./Close.tsx";
import CloseCrossImport from "./CloseCross.tsx";
import CrownImport from "./Crown.tsx";
import DevicesImport from "./Devices.png";
import DollarImport from "./Dollar.tsx";
import DropDownSelectedImport from "./DropDownSelected.tsx";
import ErrorImport from "./Error.tsx";
import ExitKidsBackgroundImport from "./ExitKidsBackground.png";
import FacebookImport from "./Facebook.tsx";
import FavoriteImport from "./Favorite.tsx";
import FavoriteFillImport from "./FavoriteFill.tsx";
import FilmImport from "./Film.tsx";
import FixtureBackImport from "./FixtureBack.tsx";
import FootballImport from "./Football.tsx";
import FooterVectorImport from "./FooterVector.png";
import ForwardImport from "./Forward.tsx";
import ForwardKidsImport from "./ForwardKids.tsx";
import FullScreenImport from "./FullScreen.tsx";
import HeartFillImport from "./HeartFill.tsx";
import InformationImport from "./Information.tsx";
import InstagramImport from "./Instagram.tsx";
import JoinLiveKidsImport from "./JoinLiveKids.tsx";
import KidsAudioBackgroundImport from "./KidsAudioBackground.png";
import KidsAudioChannelImport from "./KidsAudioChannel.png";
import KidsExitImport from "./KidsExit.tsx";
import KidsPlayImport from "./KidsPlay.tsx";
import KidsSearchImport from "./KidsSearch.tsx";
import KidsProfileImport from "./Kids_Profile.tsx";
import LargePlayImport from "./LargePlay.tsx";
import LeftArrowImport from "./LeftArrow.tsx";
import LeftArrowBackImport from "./LeftArrowBack.tsx";
import LeftRightImport from "./LeftRight.tsx";
import LockImport from "./Lock.tsx";
import LoginBackdropImport from "./LoginBackdrop.png";
import LogoChannelImport from "./LogoChannel.tsx";
import MessengerImport from "./Messenger.tsx";
import PP01Import from "./PP_01.jpg";
import PP02Import from "./PP_02.jpg";
import PP03Import from "./PP_03.jpg";
import PP04Import from "./PP_04.jpg";
import PP05Import from "./PP_05.jpg";
import PP06Import from "./PP_06.jpg";
import PP07Import from "./PP_07.jpg";
import PP08Import from "./PP_08.jpg";
import PP09Import from "./PP_09.jpg";
import PP10Import from "./PP_10.jpg";
import PP11Import from "./PP_11.jpg";
import PP12Import from "./PP_12.jpg";
import PP13Import from "./PP_13.jpg";
import PP14Import from "./PP_14.jpg";
import PP15Import from "./PP_15.jpg";
import PP16Import from "./PP_16.jpg";
import PP17Import from "./PP_17.jpg";
import PP18Import from "./PP_18.jpg";
import PP19Import from "./PP_19.jpg";
import PP20Import from "./PP_20.jpg";
import PP21Import from "./PP_21.jpg";
import PP22Import from "./PP_22.jpg";
import PP23Import from "./PP_23.jpg";
import PP24Import from "./PP_24.jpg";
import PP25Import from "./PP_25.jpg";
import PP26Import from "./PP_26.jpg";
import PP27Import from "./PP_27.jpg";
import PP28Import from "./PP_28.jpg";
import PP29Import from "./PP_29.jpg";
import PP30Import from "./PP_30.jpg";
import PP31Import from "./PP_31.jpg";
import PP32Import from "./PP_32.jpg";
import PP33Import from "./PP_33.jpg";
import PP34Import from "./PP_34.jpg";
import PP35Import from "./PP_35.jpg";
import PP36Import from "./PP_36.jpg";
import PP37Import from "./PP_37.jpg";
import PP38Import from "./PP_38.jpg";
import PP39Import from "./PP_39.jpg";
import PP40Import from "./PP_40.jpg";
import PauseKidsImport from "./PauseKids.tsx";
import PictoPauseImport from "./PictoPause.tsx";
import PictoPlayImport from "./PictoPlay.tsx";
import PictoSoundImport from "./PictoSound.tsx";
import PlatformsImport from "./Platforms.png";
import PlayImport from "./Play.tsx";
import PlayBlackImport from "./PlayBlack.tsx";
import PlayKidsImport from "./PlayKids.tsx";
import PlayWhiteImport from "./PlayWhite.tsx";
import PlayerCloseImport from "./PlayerClose.tsx";
import PlayerExitImport from "./PlayerExit.tsx";
import PremierLeagueImport from "./PremierLeague.tsx";
import ProfileImport from "./Profile.tsx";
import RatingImport from "./Rating.tsx";
import RecordImport from "./Record.tsx";
import RecordingBackDropImport from "./RecordingBackDrop.png";
import RemiderImport from "./Remider.tsx";
import ReminderImport from "./Reminder.tsx";
import RewindImport from "./Rewind.tsx";
import RewindKidsImport from "./RewindKids.tsx";
import RightArrowImport from "./RightArrow.tsx";
import RocketImport from "./Rocket.png";
import RocketRedImport from "./RocketRed.png";
import SearchImport from "./Search.tsx";
import SettingsImport from "./Settings.tsx";
import SettingsGreenImport from "./SettingsGreen.tsx";
import SettingsPinkImport from "./SettingsPink.tsx";
import ShrinkScreenImport from "./ShrinkScreen.tsx";
import SkipAdImport from "./SkipAd.tsx";
import SoundImport from "./Sound.tsx";
import StartOverImport from "./StartOver.tsx";
import StartOverKidsImport from "./StartOverKids.tsx";
import SubtitlesImport from "./Subtitles.tsx";
import SubtitlesGreenImport from "./SubtitlesGreen.tsx";
import SubtitlesRedImport from "./SubtitlesRed.tsx";
import SubtitlesWhiteImport from "./SubtitlesWhite.tsx";
import SuccessImport from "./Success.tsx";
import SynopsisImport from "./Synopsis.tsx";
import SynopsisGreenImport from "./SynopsisGreen.tsx";
import TickImport from "./Tick.tsx";
import ViewMoreArrowImport from "./ViewMoreArrow.tsx";
import WarningImport from "./Warning.tsx";
import XImport from "./X.tsx";
import YoutubeImport from "./Youtube.tsx";
import arrowleftImport from "./arrow_left.tsx";
import attemptSavedImport from "./attemptSaved.tsx";
import backdropImport from "./backdrop.jpg";
import bellRingsImport from "./bellRings.tsx";
import bellRingsOffImport from "./bellRingsOff.tsx";
import bellSnoozeImport from "./bellSnooze.tsx";
import bootlogoImport from "./boot_logo.png";
import burgerImport from "./burger.tsx";
import cardRedImport from "./cardRed.tsx";
import cardYellowImport from "./cardYellow.tsx";
import cardsImport from "./cards.tsx";
import chevronDownImport from "./chevronDown.png";
import chevronUpImport from "./chevronUp.png";
import cornerAwardedImport from "./cornerAwarded.tsx";
import exitKidsProfileBackgroundImport from "./exitKidsProfileBackground.png";
import faviconImport from "./favicon.ico";
import goalImport from "./goal.tsx";
import joinLiveImport from "./joinLive.tsx";
import landscapeImport from "./landscape.jpg";
import logoImport from "./logo.png";
import logoSVGImport from "./logoSVG.tsx";
import penaltyFacedImport from "./penaltyFaced.tsx";
import periodEndImport from "./periodEnd.tsx";
import periodStartImport from "./periodStart.tsx";
import playerOffImport from "./playerOff.tsx";
import posterImport from "./poster.jpg";
import profile1Import from "./profile1.jpg";
import profile2Import from "./profile2.jpg";
import profileAddImport from "./profileAdd.jpg";
import profileKidsImport from "./profileKids.jpg";
import profilePenImport from "./profilePen.png";
import profileTickImport from "./profileTick.png";
import shortcutKidsImport from "./shortcutKids.png";
import starhubQrcodeImport from "./starhubQrcode.png";
import videoControlsAudioSubtitlesBackgroundKidsImport from "./videoControlsAudioSubtitlesBackgroundKids.png";
import videoControlsBackgroundKids4ButtonsImport from "./videoControlsBackgroundKids4Buttons.png";
import videoControlsBackgroundKids5ButtonsImport from "./videoControlsBackgroundKids5Buttons.png";

const clientAssets = {
    'Add': AddImport,
    'Adult_Profile': AdultProfileImport,
    'ArrowDown': ArrowDownImport,
    'ArrowDownFilled': ArrowDownFilledImport,
    'ArrowLeft': ArrowLeftImport,
    'ArrowLeftNew': ArrowLeftNewImport,
    'ArrowRight': ArrowRightImport,
    'ArrowRightNew': ArrowRightNewImport,
    'ArrowUp': ArrowUpImport,
    'AudioSubtitlesKids': AudioSubtitlesKidsImport,
    'BackgroundImage': BackgroundImageImport,
    'BadgeAndoid': BadgeAndoidImport,
    'BadgeApple': BadgeAppleImport,
    'Black': BlackImport,
    'Bookmark': BookmarkImport,
    'BookmarkFilled': BookmarkFilledImport,
    'BookmarkWhite': BookmarkWhiteImport,
    'Camera': CameraImport,
    'ChannelsWhite': ChannelsWhiteImport,
    'Check': CheckImport,
    'CheckboxSelect': CheckboxSelectImport,
    'CheckboxUnselect': CheckboxUnselectImport,
    'Close': CloseImport,
    'CloseCross': CloseCrossImport,
    'Crown': CrownImport,
    'Devices': DevicesImport,
    'Dollar': DollarImport,
    'DropDownSelected': DropDownSelectedImport,
    'Error': ErrorImport,
    'ExitKidsBackground': ExitKidsBackgroundImport,
    'Facebook': FacebookImport,
    'Favorite': FavoriteImport,
    'FavoriteFill': FavoriteFillImport,
    'Film': FilmImport,
    'FixtureBack': FixtureBackImport,
    'Football': FootballImport,
    'FooterVector': FooterVectorImport,
    'Forward': ForwardImport,
    'ForwardKids': ForwardKidsImport,
    'FullScreen': FullScreenImport,
    'HeartFill': HeartFillImport,
    'Information': InformationImport,
    'Instagram': InstagramImport,
    'JoinLiveKids': JoinLiveKidsImport,
    'KidsAudioBackground': KidsAudioBackgroundImport,
    'KidsAudioChannel': KidsAudioChannelImport,
    'KidsExit': KidsExitImport,
    'KidsPlay': KidsPlayImport,
    'KidsSearch': KidsSearchImport,
    'Kids_Profile': KidsProfileImport,
    'LargePlay': LargePlayImport,
    'LeftArrow': LeftArrowImport,
    'LeftArrowBack': LeftArrowBackImport,
    'LeftRight': LeftRightImport,
    'Lock': LockImport,
    'LoginBackdrop': LoginBackdropImport,
    'LogoChannel': LogoChannelImport,
    'Messenger': MessengerImport,
    'PP_01': PP01Import,
    'PP_02': PP02Import,
    'PP_03': PP03Import,
    'PP_04': PP04Import,
    'PP_05': PP05Import,
    'PP_06': PP06Import,
    'PP_07': PP07Import,
    'PP_08': PP08Import,
    'PP_09': PP09Import,
    'PP_10': PP10Import,
    'PP_11': PP11Import,
    'PP_12': PP12Import,
    'PP_13': PP13Import,
    'PP_14': PP14Import,
    'PP_15': PP15Import,
    'PP_16': PP16Import,
    'PP_17': PP17Import,
    'PP_18': PP18Import,
    'PP_19': PP19Import,
    'PP_20': PP20Import,
    'PP_21': PP21Import,
    'PP_22': PP22Import,
    'PP_23': PP23Import,
    'PP_24': PP24Import,
    'PP_25': PP25Import,
    'PP_26': PP26Import,
    'PP_27': PP27Import,
    'PP_28': PP28Import,
    'PP_29': PP29Import,
    'PP_30': PP30Import,
    'PP_31': PP31Import,
    'PP_32': PP32Import,
    'PP_33': PP33Import,
    'PP_34': PP34Import,
    'PP_35': PP35Import,
    'PP_36': PP36Import,
    'PP_37': PP37Import,
    'PP_38': PP38Import,
    'PP_39': PP39Import,
    'PP_40': PP40Import,
    'PauseKids': PauseKidsImport,
    'PictoPause': PictoPauseImport,
    'PictoPlay': PictoPlayImport,
    'PictoSound': PictoSoundImport,
    'Platforms': PlatformsImport,
    'Play': PlayImport,
    'PlayBlack': PlayBlackImport,
    'PlayKids': PlayKidsImport,
    'PlayWhite': PlayWhiteImport,
    'PlayerClose': PlayerCloseImport,
    'PlayerExit': PlayerExitImport,
    'PremierLeague': PremierLeagueImport,
    'Profile': ProfileImport,
    'Rating': RatingImport,
    'Record': RecordImport,
    'RecordingBackDrop': RecordingBackDropImport,
    'Remider': RemiderImport,
    'Reminder': ReminderImport,
    'Rewind': RewindImport,
    'RewindKids': RewindKidsImport,
    'RightArrow': RightArrowImport,
    'Rocket': RocketImport,
    'RocketRed': RocketRedImport,
    'Search': SearchImport,
    'Settings': SettingsImport,
    'SettingsGreen': SettingsGreenImport,
    'SettingsPink': SettingsPinkImport,
    'ShrinkScreen': ShrinkScreenImport,
    'SkipAd': SkipAdImport,
    'Sound': SoundImport,
    'StartOver': StartOverImport,
    'StartOverKids': StartOverKidsImport,
    'Subtitles': SubtitlesImport,
    'SubtitlesGreen': SubtitlesGreenImport,
    'SubtitlesRed': SubtitlesRedImport,
    'SubtitlesWhite': SubtitlesWhiteImport,
    'Success': SuccessImport,
    'Synopsis': SynopsisImport,
    'SynopsisGreen': SynopsisGreenImport,
    'Tick': TickImport,
    'ViewMoreArrow': ViewMoreArrowImport,
    'Warning': WarningImport,
    'X': XImport,
    'Youtube': YoutubeImport,
    'arrow_left': arrowleftImport,
    'attemptSaved': attemptSavedImport,
    'backdrop': backdropImport,
    'bellRings': bellRingsImport,
    'bellRingsOff': bellRingsOffImport,
    'bellSnooze': bellSnoozeImport,
    'boot_logo': bootlogoImport,
    'burger': burgerImport,
    'cardRed': cardRedImport,
    'cardYellow': cardYellowImport,
    'cards': cardsImport,
    'chevronDown': chevronDownImport,
    'chevronUp': chevronUpImport,
    'cornerAwarded': cornerAwardedImport,
    'exitKidsProfileBackground': exitKidsProfileBackgroundImport,
    'favicon': faviconImport,
    'goal': goalImport,
    'joinLive': joinLiveImport,
    'landscape': landscapeImport,
    'logo': logoImport,
    'logoSVG': logoSVGImport,
    'penaltyFaced': penaltyFacedImport,
    'periodEnd': periodEndImport,
    'periodStart': periodStartImport,
    'playerOff': playerOffImport,
    'poster': posterImport,
    'profile1': profile1Import,
    'profile2': profile2Import,
    'profileAdd': profileAddImport,
    'profileKids': profileKidsImport,
    'profilePen': profilePenImport,
    'profileTick': profileTickImport,
    'shortcutKids': shortcutKidsImport,
    'starhubQrcode': starhubQrcodeImport,
    'videoControlsAudioSubtitlesBackgroundKids': videoControlsAudioSubtitlesBackgroundKidsImport,
    'videoControlsBackgroundKids4Buttons': videoControlsBackgroundKids4ButtonsImport,
    'videoControlsBackgroundKids5Buttons': videoControlsBackgroundKids5ButtonsImport,
}
export default clientAssets
